import styled, { css } from 'styled-components'

import { LoadingProps } from '.'

export const Loading = styled.div<LoadingProps>`
  ${({ theme, width, height }) => css`
    width: ${width ? width : '20px'};
    height: ${height ? height : '20px'};
    border-radius: 50%;
    position: relative;
    animation: rotate 1s linear infinite;

    &::before,
    &::after {
      content: '';
      box-sizing: border-box;
      position: absolute;
      inset: 0px;
      border-radius: 50%;
      border: 2px solid ${theme.ds.colors.primary600};
      animation: prixClipFix 2s linear infinite;
    }
    &::after {
      transform: rotate3d(90, 90, 0, 180deg);
      border-color: ${theme.ds.colors.primary600};
    }

    @keyframes rotate {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    @keyframes prixClipFix {
      0% {
        clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
      }
      50% {
        clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);
      }
      100% {
        clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
      }
    }
  `}
`
